/**
 * Typ externího zdroje vrstev.
 */
export enum ExternalType {
    FILE = 'file',
    WMS = 'WMS',
}